import { PropsWithChildren } from "react";
import { NavbarElementProps } from "./navbarDesktopElement.types";
import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { clsx } from "clsx/lite";

export function NavbarElement({
  icon,
  iconSelected,
  children,
  path,
}: PropsWithChildren<NavbarElementProps>) {
  const location = useLocation();

  return (
    <>
      {path.startsWith("/settings") && <div className="flex grow" />}
      <Link
        to={path}
        className={clsx(
          "flex",
          "flex-row",
          "justify-start",
          "h-6",
          "gap-1",
          "items-center",
          "hover:cursor-pointer",
          "group",
          "pr-2",
        )}
      >
        <div
          className={clsx(
            "w-0.5",
            "rounded-full",
            "bg-primary",
            "group-hover:h-6",
            "duration-200",
            "ease-in-out",
            location.pathname.startsWith(path) ? "h-6" : "h-0",
          )}
        />
        <div className="w-8 justify-center items-center flex">
          <FontAwesomeIcon
            icon={location.pathname.startsWith(path) ? iconSelected : icon}
            className={clsx(
              location.pathname.startsWith(path)
                ? "text-primary"
                : "text-font-secondary",
              "text-lg",
            )}
          />
        </div>
        <div
          className={clsx(
            location.pathname.startsWith(path)
              ? "text-font-black"
              : "text-font-secondary",
            "text-base",
            "pt-px",
          )}
        >
          {children}
        </div>
      </Link>
    </>
  );
}
